import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toast'
import styled from 'styled-components'
import { supabase } from '../../../App'
import { setModal } from '../../../redux/modals-reducer'

export const Wrapper = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    padding: 60px 48px 10px;
    border-radius: 20px;
    background: #fff;
    transform: translate(-50%, -50%);
    max-width: 430px;
    display: flex;
    flex-direction: column;

    img {
        width: 140px;
        margin: 0 auto 32px;
    }
    h2 {
        font-size: 20px;
        text-align: center;
        margin-bottom: 24px;
        line-height: 140%;
    }
    p {
        font-size: 14px;
        margin-bottom: 24px;
        font-weight: 300;
        line-height: 1.3;
    }

    .input_block {
        border: 2px solid #b3bcc5;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        padding: 0 6px 10px 10px;
        &:nth-child(n + 2) {
            margin-top: 15px;
        }
    }
    label {
        font-size: 12px;
        font-weight: 300;
    }
    input {
        font-size: 16px;
        line-height: 20px;
    }
    button.submit {
        width: 100%;
        background: #7f55ff;
        opacity: 0.9;
        border-radius: 5px;
        min-height: 48px;
        min-width: 192px;
        padding: 0 20px;
        margin-top: 15px;
        font-weight: bold;
        color: #fff;
        transition: 0.3s all ease;
        &:hover {
            opacity: 1;
        }
    }
    svg {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
    }

    .bottom_text {
        cursor: pointer;
        text-align: center;
        margin-top: 20px;
        font-size: 13px;
        font-weight: 500;
    }
`

const Auth = () => {
    const dispatch = useDispatch()
    const [loginData, setLoginData] = useState({
        email: null,
        password: null,
    })

    const login = async () => {
        let { user, error } = await supabase.auth.signIn({
            email: loginData.email,
            password: loginData.password,
        })

        if (user) {
            toast.success('You are logged in 👋')
            window.location.replace('/catalog')
        }

        if (error) {
            toast.error(error.message)
        }
    }

    return (
        <Wrapper>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                class="ui-g1"
                onClick={(e) => {
                    e.preventDefault()
                    dispatch(setModal(null))
                }}
            >
                <path
                    fill="#000"
                    d="m12 10.586 6.293-6.295a1 1 0 0 1 1.414 1.414L13.414 12l6.293 6.294a1 1 0 1 1-1.414 1.415L12 13.414 5.707 19.71a1 1 0 0 1-1.414-1.415L10.586 12 4.293 5.705a1 1 0 1 1 1.414-1.414L12 10.586Z"
                ></path>
            </svg>
            <img
                src="https://height.app/a/statics/assets/logo.C7N3MDIK.svg"
                alt=""
            />
            <h2>Введите свою электронную почту, чтобы войти</h2>

            <form>
                <div className="input_block">
                    <label>Почта</label>
                    <input
                        type="text"
                        onChange={(e) =>
                            setLoginData({
                                ...loginData,
                                email: e.target.value,
                            })
                        }
                        value={loginData.email}
                    />
                </div>
                <div className="input_block">
                    <label>Пароль</label>
                    <input
                        type="password"
                        onChange={(e) =>
                            setLoginData({
                                ...loginData,
                                password: e.target.value,
                            })
                        }
                        value={loginData.password}
                    />
                </div>
                <button
                    className="submit"
                    onClick={(e) => {
                        e.preventDefault()
                        login()
                    }}
                >
                    Войти
                </button>
            </form>
            <p
                className="bottom_text"
                onClick={() => dispatch(setModal('REGISTER'))}
            >
                Нет аккаунта?
            </p>
        </Wrapper>
    )
}

export default Auth
